export const SIGN_IN_PATH = '/login';
const HOME_PATH = '/';

// Any origin works: it only shows whether a value would leave this one.
const BASE = 'https://return-path.invalid';

/**
 * Where to go after signing in: the page the user asked for, if it is a page of
 * this app. Anything else, such as another site, a protocol-relative URL or the
 * sign-in page itself, goes home instead, so the `redirect` parameter can't send
 * anyone elsewhere.
 */
export function safeReturnPath(value: unknown): string {
  if (typeof value !== 'string' || !value.startsWith('/')) {
    return HOME_PATH;
  }
  let url: URL;
  try {
    url = new URL(value, BASE);
  } catch {
    return HOME_PATH;
  }
  // Catches `//host`, `/\host` and the tabs or newlines browsers strip from URLs.
  if (url.origin !== BASE || url.pathname === SIGN_IN_PATH) {
    return HOME_PATH;
  }
  return `${url.pathname}${url.search}${url.hash}`;
}
